import script from "./ThePersonalDataForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ThePersonalDataForm.vue?vue&type=script&setup=true&lang=js"

import "./ThePersonalDataForm.vue?vue&type=style&index=0&id=31e85659&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31e85659"]])

export default __exports__